/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react'
import { Col, Input, Row, Typography } from 'antd'
import UsersTable from 'component/Client/UsersTable'

interface PropTypes {
	clientId: string
}

const { Title } = Typography
const { Search } = Input

const UsersLayout: React.FC<PropTypes> = ({ clientId }) => {
	const [query, setQuery] = useState('')

	return (
		<Row>
			<Col span={14}>
				<Title level={2}>Clients</Title>
			</Col>
			<Col span={10}>
				<Search
					onSearch={setQuery}
					placeholder='Search Users Name/Email/Mobile'
					allowClear
					enterButton
				/>
			</Col>

			<Col span={24}>
				<UsersTable clientId={clientId} query={query} />
			</Col>
		</Row>
	)
}

export default UsersLayout
